import * as React from "react";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { useSelector } from "react-redux";

import { Grid, Loader } from "semantic-ui-react";

import { AuditLogTable } from "../../../audit/components/AuditLogTable";

import { AuditLogEntryDto } from "../../../audit/model";
import { ApplicationState } from "../../../applicationState";
import { useEmployeeRecordDetailsModel } from "../hooks";
import { employeeRecordApi } from "../employeeRecordApi";

export const EmployeeRecordAuditLog = () => {
    const enabledEmployeeAuditLogs = getFeatureToggles()[FeatureToggleNames.EnableEmployeeAuditLogs];

    const employeeRecordId = useSelector((state: ApplicationState) => state.router.params!.employeeRecordId);
    const customerId = useSelector((state: ApplicationState) => state.router.params!.customerId);
    const { employeeRecord, isLoaded: isEmployeeLoaded } = useEmployeeRecordDetailsModel({
        employeeRecordId,
        customerId
    });
    const [auditLogs, setAuditLogs] = React.useState<AuditLogEntryDto[] | null | undefined>(undefined);

    React.useEffect(() => {
        const getAuditLogs = async () => {
            if (customerId && employeeRecordId) {
                const data = await employeeRecordApi.getAuditLogs(customerId, employeeRecordId);
                setAuditLogs(data);
            }
        };

        if (auditLogs === undefined) {
            getAuditLogs();
        }

    }, [auditLogs, customerId, employeeRecordId]);

    if (!enabledEmployeeAuditLogs) {
        return null;
    }

    if (auditLogs === undefined || !isEmployeeLoaded) {
        return <Loader active />;
    }

    return (
        <>
            <Grid className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>Audit Log for {employeeRecord.firstName} {employeeRecord.lastName}</h1>
                    </Grid.Column>
                </Grid.Row>
                <AuditLogTable auditLogs={auditLogs} />
            </Grid>
        </>
    );
};
